import React,{useEffect, useState} from "react";
import { apiUrl, assetsUrl } from "../config/Config";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";

const Alumniregistration = () => {
    const [name, setname] = useState("");
    const [email, setemail] = useState("");
    const [phonenumber, setphonenumber] = useState("");
    const [course, setcourse] = useState("");
    const [passoutyear, setpassoutyear] = useState("");
    const [designation, setdesignation] = useState("");
    const [currentaddress, setcurrentaddress] = useState("");
    const [otherinfo, setotherinfo] = useState("");
    const [image, setimage] = useState("");

    const [coursedata, setcoursedata] = useState([]);
    const [showloading, setshowloding] = useState(false);

    const getBase64 = (file) => {
      return new Promise((resolve) => {
        let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();
  
        // Convert the file to base64 text
        reader.readAsDataURL(file);
  
        // on reader load somthing...
        reader.onload = () => {
          // Make a fileInfo Object
          // console.log("Called", reader);
          baseURL = reader.result;
          // console.log(baseURL);
          resolve(baseURL);
        };
        // console.log(fileInfo);
      });
    };
  
    const handleinputchange = async (file) => {
      var obj = {};
      await getBase64(file).then((result) => {
        obj["name"] = file.name;
        obj["image"] = result;
      });
      // console.log('obj >>', obj);
      setimage(obj);
    };

    const submithandle = async() => {
      if(name && email && phonenumber && course && passoutyear && designation && currentaddress ) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(email)) {
                Swal.fire({
                    title: '',
                    text: "Invalid Email Address",
                    icon: 'error',
                    customClass: {
                      icon: 'custom-swal-icon' // Apply the custom class
                    },
                    width: '350px',
                    confirmButtonText: 'Ok',
                confirmButtonColor: "rgb(59, 151, 196)",
                    customClass: {
                        popup: "small-icon-alert",
                      },
                  });
                return
              } else {
                
              }

        var data = {
          name: name,
          email: email,
          phonenumber: phonenumber,
          course: course,
          passoutyear: passoutyear,
          designation: designation,
          currentaddress: currentaddress,
          otherinfo: otherinfo,
          image: image
        }

        const headers = {
          headers: {
            "Content-Type": "application/json"
          },
        };

        let resp = await axios
        .post(apiUrl + "submitregistration", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            setshowloding(false);
            Swal.fire({
              title: '',
              text: "Registered Successfully",
              icon: 'success',
              customClass: {
                icon: 'custom-swal-icon' // Apply the custom class
              },
              width: '350px',
              confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
              customClass: {
                  popup: "small-icon-alert",
                },
            });
            // window.location.reload();
            setname("");
            setemail("");
            setphonenumber("");
            setcourse("");
            setpassoutyear("");
            setdesignation("");
            setcurrentaddress("");
            setotherinfo("");
            setimage("");
            setshowloding(false);
          } else {
            if(res.data.message == 'Email Already exist') {
              Swal.fire({
                title: '',
                text: "Email already exist",
                icon: 'error',
                customClass: {
                  icon: 'custom-swal-icon' // Apply the custom class
                },
                width: '350px',
                confirmButtonText: 'Ok',
            confirmButtonColor: "rgb(59, 151, 196)",
                customClass: {
                    popup: "small-icon-alert",
                  },
              });
            } else {
              alert(res.data.message)
            }
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });

        console.log('data >>', data);

      } else {
        Swal.fire({
          title: 'Wait',
          text: "Mandatory Fields cannot be empty",
          icon: 'warning',
          customClass: {
            icon: 'custom-swal-icon' // Apply the custom class
          },
          width: '350px',
          confirmButtonText: 'Ok',
      confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
              popup: "small-icon-alert",
            },
        });
      }
    }

    const fetchcourses = async() => {
      setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let resp = await axios
          .get(apiUrl + "getuserallalumnicourses", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
              console.log('prevdata >>', prevdata);
              setcoursedata(prevdata);
              
              // setcoursesdata(res.data.data);
            } else {
              // alert(res.data.message);
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
    }

    const handleChangeNumber = (e) => {
      const newValue = e.target.value;
      if (/^[0-9+()]*$/.test(newValue) && newValue.length <= 10) {
          setphonenumber(newValue);
        }
    };

    const handleChangeYear = (e) => {
      const newValue = e.target.value;
      if (/^[0-9+()]*$/.test(newValue) && newValue.length <= 4) {
          setpassoutyear(newValue);
        }
    };

    useEffect(() => {
      fetchcourses()
    }, [])

    return(
      <div>
           <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">Alumni Registration</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                    Alumni Registration</p>
                </div>
            </section>

            <section className="hod-main-sec ">
                <div className="container">
                <p className="ab-depart-subheading text-center">SVU Zoology Alumni Association</p>
            <p className="home-about-head text-center">Alumni Registration</p>
            <p className="museum-main-para text-center">Reconnect, collaborate, and contribute to the legacy of the SVU Zoology Department. Register now to stay informed about alumni events, share your achievements, and support the next generation of zoologists. Together, let’s celebrate our shared journey and inspire the future!</p>
           
                

            <div className="alumniregistration-div">
        <div className="mb-3">
          <label className="form-label">Name <span className="text-danger">*</span></label>
          <input type="text" className="form-control" placeholder="Enter your name" value={name} onChange={(t) => {setname(t.target.value)}} />
        </div>

        <div className="mb-3">
          <label className="form-label">Email <span className="text-danger">*</span></label>
          <input type="email" className="form-control" placeholder="Enter your email" value={email} onChange={(t) => {setemail(t.target.value)}} />
        </div>

        <div className="mb-3">
          <label className="form-label">Phone Number <span className="text-danger">*</span></label>
          <input type="text" className="form-control" placeholder="Enter mobile number"
                                            min="1000000000"
                                            max="9999999999"
                                            value={phonenumber}
                                            onChange={handleChangeNumber}
                                            />
        </div>

        <div className="mb-3">
          <label className="form-label">Course / Department <span className="text-danger">*</span></label>
          {/* <input type="text" className="form-control" /> */}
          <select className="form-select" value={course} onChange={(t) => {setcourse(t.target.value)}} >
            <option value={""} selected disabled>Select course</option>
            {
              coursedata?.length > 0 ?
              coursedata?.map((item, index) => {
                return (
                  <option value={item?.id} key={index}>{item?.name}</option>
                )
              }) :
              null
            }
          </select>

        </div>

        <div className="mb-3">
          <label className="form-label">Year of Passed Out <span className="text-danger">*</span></label>
          <input type="text" className="form-control" 
          placeholder="Enter Year of Passed Out"
          min="1900" max="2099"
          value={passoutyear}
          onChange={handleChangeYear}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Professional Designation <span className="text-danger">*</span></label>
          <select className="form-select" value={designation} onChange={(t) => {setdesignation(t.target.value)}}>
          <option value={""} disabled selected>Select designation</option>
            <option value={"Teaching"}>Teaching</option>
            <option value={"Research"}>Research</option>
            <option value={"Industry"}>Industry</option>
            <option value={"Student"}>Student</option>
            <option value={"Other"}>Other</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Current Address <span className="text-danger">*</span></label>
          <input type="text" className="form-control" placeholder="Enter Current Address" value={currentaddress} onChange={(t) => {setcurrentaddress(t.target.value)}} />
        </div>

        <div className="mb-3">
          <label className="form-label">Seek Any other Info?</label>
          <textarea className="form-control" rows="3" placeholder="Other Info" value={otherinfo} onChange={(t) => {setotherinfo(t.target.value)}}></textarea>
        </div>

        <div className="mb-3">
          <label className="form-label">Batch Group Photo (if any)</label>
          <input className="form-control"
          onChange={(t) => {
            handleinputchange(t.target.files[0]);
          }}
            accept="image/*"
            type="file"
          />
        </div>

        <div type="submit" className="btn btn-primary  submit-registration-btn" onClick={() => {submithandle()}}>
          {
            showloading ?
            <Spinner color='#fff' size={16} className='spinnerCenter' /> :
            "SEND"
          }
        </div>
      </div>
                
                
                </div>




    
            </section>
      </div>
    )
}
export default Alumniregistration;